import styled from 'styled-components';

import { fontFamilySize, px } from '../../../../../contrib/ui';

export const UpcomingEventsStyled = styled.div`
  width: 100%;
  padding-left: ${px(14)};
  padding-right: ${px(14)};

  h3 {
    text-align: center;
    ${fontFamilySize('Heavy', 20)};
  }

  .events-container {
    margin-bottom: px(20);
    padding: 0 px(15);
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
  }
`;
